import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger/shared';
import { fetchMessagesUnread, TMessagesUnreadResponse } from '../../../repositories/chats/v1/messages-unread';

export async function getUnreadMessages(httpApi: IHttpApi, logger: ILogger) {
  try {
    const result = (await fetchMessagesUnread({ httpApi, parameters: {} })) as TMessagesUnreadResponse;

    if (result.statusCode === 200) {
      return result.response.unread as number;
    }

    return null;
  } catch (error) {
    logger.debug(error);

    return null;
  }
}
